module.exports = __webpack_public_path__ + "img/err-list.28dc1e27.svg";